import * as React from "react"
import ProductFilterType from "../../../model/ProductFilterType"
import AccordionHeader from "../../accordion/AccordionHeader"
import AccordionBody from "../../accordion/AccordionBody"
import AccordionItem from "../../accordion/AccordionItem"
import styled from "styled-components"
import { ProductType } from "model"
import { getPriceRange } from "model"

const Body = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
`
const Input = styled.input`
  width: 75px;
`

const PriceFilter: ProductFilterType = ({ state, onChange, ...props }) => {
  const min = state?.min || undefined
  const max = state?.max || undefined

  return (
    <AccordionItem {...props}>
      <AccordionHeader>
        Price {min && !max && <small>£{min} or more</small>}
        {!min && max && <small>£{max} or less</small>}
        {min && max && (
          <small>
            £{min} - £{max}
          </small>
        )}
      </AccordionHeader>
      <AccordionBody>
        <Body>
          £
          <Input
            placeholder="min"
            type="number"
            min={0}
            onChange={event =>
              onChange({ ...state, min: event.target.value ? parseInt(event.target.value) : null })
            }
            value={min}
          />{" "}
          - £
          <Input
            placeholder="max"
            type="number"
            min={0}
            onChange={event =>
              onChange({ ...state, max: event.target.value ? parseInt(event.target.value) : null })
            }
            value={max}
          />
        </Body>
      </AccordionBody>
    </AccordionItem>
  )
}

PriceFilter.filter = (product: ProductType, state: any) => {
  const priceRange = getPriceRange(product)
  if (!state) {
    return true
  } else if (state.min && state.max) {
    return priceRange[1] > state.min && priceRange[0] < state.max
  } else if (state.min) {
    return priceRange[1] > state.min
  } else if (state.max) {
    return priceRange[0] < state.max
  } else {
    return true
  }
}

PriceFilter.filterName = "price"

export default PriceFilter
